import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { getDevData } from "../../services/generalService";
import { PaymentReversalTransactionObj } from "../../utils/types";

const initialState: PaymentReversalTransactionObj = {
  data: null,
  isLoading: true,
  isSuccess: false,
  isError: false,
};

export const getPaymentReversalTransactionDetails = createAsyncThunk(
  "loans/getPaymentReversalTransactionDetails",
  async (url: string, thunkAPI) => {
    try {
      const data = await getDevData(url);
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

const paymentReversalTransactionSlice = createSlice({
  name: "payment-reversal-transaction-details",
  initialState,
  reducers: {
    // synchronous aperations goes here
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPaymentReversalTransactionDetails.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(
        getPaymentReversalTransactionDetails.fulfilled,
        (state, action) => {
          state.isLoading = false;
          state.isError = false;
          state.isSuccess = true;
          state.data = action.payload;
        }
      )
      .addCase(
        getPaymentReversalTransactionDetails.rejected,
        (state, action) => {
          state.isLoading = false;
          state.isError = true;
          state.isSuccess = false;
          state.data = null;
        }
      );
  },
});

export default paymentReversalTransactionSlice.reducer;
